import apiCall from '../../apiCall/apiCall';
// This class handles any API calls related to jobs.
class Job {
  static show(id) {
    return apiCall('GET', `api/jobs/bookings/${id}`);
  }
}

export default Job;
